/**
 * @generated SignedSource<<dc5b96926ec396a3ae97da410b7ef114>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastFocusBottomSheetClearTemporaryScreeensMutation$variables = {
  storecastId: string;
};
export type StorecastFocusBottomSheetClearTemporaryScreeensMutation$data = {
  readonly dashboard: {
    readonly clearTemporaryScreens: number | null;
  };
};
export type StorecastFocusBottomSheetClearTemporaryScreeensMutation = {
  response: StorecastFocusBottomSheetClearTemporaryScreeensMutation$data;
  variables: StorecastFocusBottomSheetClearTemporaryScreeensMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clearTemporaryScreens",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastFocusBottomSheetClearTemporaryScreeensMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StorecastFocusBottomSheetClearTemporaryScreeensMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f49b1811d21b57b3686ca7a00ee50ffc",
    "id": null,
    "metadata": {},
    "name": "StorecastFocusBottomSheetClearTemporaryScreeensMutation",
    "operationKind": "mutation",
    "text": "mutation StorecastFocusBottomSheetClearTemporaryScreeensMutation(\n  $storecastId: ID!\n) {\n  dashboard(dashboardId: $storecastId) {\n    clearTemporaryScreens\n  }\n}\n"
  }
};
})();

(node as any).hash = "e578617826d3be1944742d77ef8af76f";

export default node;
